/* Ontwerpstudio ronde stickers 3 tot 35 cm voor ricardwebshop.nl.

   De rekenkern komt uit pv-stickers-studio.js: mmx, klem, laadBeeld, zetFont,
   passendFontPx, punt, inRechthoek, pakOp, verplaats en laatLos staan daar al
   maanden goed. Alles wordt in millimeters gerekend en pas bij het tekenen
   naar pixels gezet, net als daar.

   Wat hier anders is dan bij de PV-studio: de sticker is ROND. Daarom een
   cirkelvormig clippad in plaats van een afgeronde rechthoek, een controle op
   vier hoekpunten in plaats van op een rechthoek, en geen klem die het logo
   binnen de sticker houdt. De klant mag alles vrij neerzetten, ook over de
   rand; dan komt er een gele regel in beeld en kijkt Richard er voor het
   drukken naar.

   Opbouw van onder naar boven: de ondergrond (het gekozen bord), het logo,
   de drie tekstregels, en bovenop het sleepblokje van het logo. */
(function () {
  "use strict";

  var canvas = document.getElementById("rs-canvas");
  if (!canvas || !canvas.getContext) { return; }
  var ctx = canvas.getContext("2d");

  /* ---------- maten uit het bronbestand ---------- */

  // bestel/999.ai is een artboard van 106 mm met de CutContour-cirkel erin.
  // Die cirkel is de snijlijn en dus de sticker zelf. Gemeten op 21-09-2026
  // door de laag CutContour los te renderen: 1184 van 1252 px, dus 100,24 mm.
  // De ondergronden zijn het HELE artboard, daarom moet het bord iets groter
  // dan de sticker getekend worden; de witte hoeken vallen buiten het clippad.
  var ARTBOARD_MM = 106.0;
  var SNIJ_MM = 100.24;
  var BORD_DEEL = ARTBOARD_MM / SNIJ_MM;          // 1,0575

  // Hetzelfde geharde uploadpunt als de keuringsstickers- en de PV-studio.
  // Er komt er geen nieuwe bij; de liquid mag hem overschrijven.
  var UPLOAD_URL = window.STUDIO_UPLOAD_URL
    || "https://keuringsstickers-nen.nl/studio/upload.php";
  var MAX_UPLOAD_MB = 8;

  // Zolang blijft "de foto uploaden lukte niet"-melding in beeld voor we
  // doorgaan naar de winkelwagen. Zonder deze pauze navigeert de pagina meteen
  // weg en heeft de klant de melding nooit kunnen lezen (de bestelling zelf
  // wacht er niet op, die gaat sowieso door).
  var MELDING_PAUZE_MS = 1800;

  // De tekenruimte in logische pixels (de maat uit het canvas-attribuut). Op
  // een retinascherm staan er meer echte pixels op elke logische, maar alle
  // coordinaten hier blijven logisch; hiDPI() zet daar de schaal voor.
  var LOGISCH = canvas.width || 1000;
  var MARGE_DEEL = 0.05;                          // witruimte rondom, deel van de doorsnede
  var DPR = 1;

  // De doorsnede van de sticker in mm. Verandert mee met de keuzelijst #rs-maat,
  // want een tekst van 7 pt is op 3 cm iets heel anders dan op 35 cm.
  var MAAT_MM = 100;
  var PX_PER_MM = 1;

  /* ---------- tekst ---------- */

  // Vijf websafe lettertypes, zodat er niets geladen hoeft te worden en het
  // scherm hetzelfde toont als de druk.
  var FONTS = [
    { sleutel: "arial", naam: "Arial", css: "Arial, Helvetica, sans-serif", gewicht: "400" },
    { sleutel: "arialvet", naam: "Arial vet", css: "Arial, Helvetica, sans-serif", gewicht: "700" },
    { sleutel: "helvetica", naam: "Helvetica", css: "Helvetica, Arial, sans-serif", gewicht: "400" },
    { sleutel: "times", naam: "Times", css: "'Times New Roman', Times, serif", gewicht: "400" },
    { sleutel: "courier", naam: "Courier", css: "'Courier New', Courier, monospace", gewicht: "400" }
  ];

  var BASIS_TEKST_DEEL = 0.12;   // korps bij schaal 1,0 als deel van de doorsnede
  var SCHAAL_MIN = 0.25;
  var SCHAAL_MAX = 1.5;
  var MIN_PT = 7;                // kleiner drukt de machine niet leesbaar
  var MM_PER_PT = 25.4 / 72;
  var STANDAARD_KLEUR = "#1d1d1b";

  /* ---------- de stand van zaken ---------- */

  var state = {
    bord: null,        // {naam, bestand, laag, ring, cijfer, url} van de gekozen tegel
    bordBeeld: null,
    logo: null,        // null zolang er geen logo is, anders {beeld, url, x, y, breedte}
    teksten: [
      { inhoud: "", x: 0.5, y: 0.62, schaal: 0.6875, ruw: 0.6875, kleur: STANDAARD_KLEUR, font: "arial" },
      { inhoud: "", x: 0.5, y: 0.74, schaal: 0.6875, ruw: 0.6875, kleur: STANDAARD_KLEUR, font: "arial" },
      { inhoud: "", x: 0.5, y: 0.86, schaal: 0.6875, ruw: 0.6875, kleur: STANDAARD_KLEUR, font: "arial" }
    ],
    maat: "",          // "10 cm", zoals de klant het kiest
    aantal: "",        // "25 stuks"
    variantId: null,
    snapshotUrl: "",   // vult taak 5
    bezig: false
  };

  var sleep = null;

  /* ---------- hulpjes ---------- */

  function mmx(v) { return v * PX_PER_MM; }
  function klem(v, laag, hoog) { return Math.max(laag, Math.min(hoog, v)); }

  function zetMaat(mm) {
    MAAT_MM = mm;
    PX_PER_MM = LOGISCH / (MAAT_MM * (1 + 2 * MARGE_DEEL));
  }

  function margeMm() { return MAAT_MM * MARGE_DEEL; }
  function doorsnedePx() { return mmx(MAAT_MM); }

  function laadBeeld(url, klaar) {
    var img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = function () { klaar(img); };
    img.onerror = function () { klaar(null); };
    img.src = url;
  }

  function font(sleutel) {
    for (var i = 0; i < FONTS.length; i++) {
      if (FONTS[i].sleutel === sleutel) { return FONTS[i]; }
    }
    return FONTS[0];
  }

  /* ---------- meldingen ---------- */

  function toonFout(tekst) {
    var el = document.getElementById("rs-foutmelding");
    if (!el) { return; }
    el.textContent = tekst || "";
    el.hidden = !tekst;
  }

  function toonLogoStatus(tekst, isFout) {
    var el = document.getElementById("rs-logostatus");
    if (!el) { return; }
    el.textContent = tekst || "";
    el.classList.toggle("is-fout", !!isFout);
  }

  /* ---------- korps en lettertype ---------- */

  function basisTekstMm() { return MAAT_MM * BASIS_TEKST_DEEL; }

  /** De kleinste schaal die op deze maat nog 7 pt oplevert. */
  function minimaleSchaal() {
    return klem((MIN_PT * MM_PER_PT) / basisTekstMm(), SCHAAL_MIN, SCHAAL_MAX);
  }

  /** Zet de schaal van deze regel uit de stand van zijn schuif. `ruw` is wat
      de klant vraagt, `schaal` is wat het wordt: nooit onder de 7 pt. Het
      verschil tussen die twee is precies wanneer de melding hoort te komen. */
  function zetSchaalUitSchuif(tekst, waarde) {
    tekst.ruw = SCHAAL_MIN + (SCHAAL_MAX - SCHAAL_MIN) * (Number(waarde) / 100);
    tekst.schaal = Math.max(minimaleSchaal(), tekst.ruw);
  }

  /** Het korps in px. Anders dan bij de PV-studio krimpt een te lange regel
      hier NIET mee naar binnen: de klant mag vrij plaatsen en over de rand
      lopen, dat meldt controleerRanden() hem. Wat wel vastligt is de bodem van
      7 pt, want daaronder drukt de machine het niet leesbaar. */
  function passendFontPx(t, inhoud, schaal) {
    var bodemMm = MIN_PT * MM_PER_PT;
    return mmx(Math.max(bodemMm, basisTekstMm() * schaal));
  }

  function zetFont(t, tekst) {
    var px = passendFontPx(t, tekst.inhoud || "", tekst.schaal);
    var f = font(tekst.font);
    t.font = f.gewicht + " " + px.toFixed(2) + "px " + f.css;
    return px;
  }

  function meldKleineTekst() {
    var vak = document.getElementById("rs-tekstmelding");
    if (!vak) { return; }
    var grens = minimaleSchaal();
    var klein = state.teksten.some(function (t) {
      return t.inhoud && t.ruw < grens - 0.0005;
    });
    vak.hidden = !klein;
    vak.textContent = klein
      ? "Kleiner dan dit wordt de tekst in druk onleesbaar, dus hier houdt de "
        + "schuif op."
      : "";
  }

  /* ---------- posities ---------- */

  function logoRechthoek() {
    if (!state.logo || !state.logo.beeld) { return null; }
    var d = doorsnedePx();
    var beeld = state.logo.beeld;
    var bb = beeld.naturalWidth || beeld.width || 1;
    var bh = beeld.naturalHeight || beeld.height || bb;
    var b = state.logo.breedte * d;
    var h = b * (bh / bb);
    return { x: state.logo.x * d - b / 2, y: state.logo.y * d - h / 2, b: b, h: h };
  }

  function tekstRechthoek(tekst) {
    var inhoud = (tekst.inhoud || "").trim();
    if (!inhoud) { return null; }
    var d = doorsnedePx();
    var h = zetFont(ctx, tekst);
    var b = ctx.measureText(inhoud).width;
    return { x: tekst.x * d - b / 2, y: tekst.y * d - h / 2, b: b, h: h };
  }

  /** Het blokje rechtsonder aan het logo waarmee de klant het groter maakt. */
  function logoGreep() {
    var r = logoRechthoek();
    if (!r) { return null; }
    var maat = klem(doorsnedePx() * 0.05, 16, 40);
    return { x: r.x + r.b - maat / 2, y: r.y + r.h - maat / 2, b: maat, h: maat };
  }

  /* ---------- tekenen ---------- */

  function clipCirkel(t) {
    t.beginPath();
    t.arc(mmx(MAAT_MM / 2), mmx(MAAT_MM / 2), mmx(MAAT_MM / 2), 0, Math.PI * 2);
    t.clip();
  }

  function tekenOndergrond(t) {
    var d = doorsnedePx();
    t.fillStyle = "#ffffff";
    t.fillRect(0, 0, d, d);
    if (!state.bordBeeld) { return; }
    // Het bord staat op een artboard van 106 mm terwijl de sticker 100,24 mm
    // is, dus iets groter tekenen en dan gecentreerd.
    var b = d * BORD_DEEL;
    var uit = (d - b) / 2;
    t.drawImage(state.bordBeeld, uit, uit, b, b);
  }

  function tekenTeksten(t) {
    var d = doorsnedePx();
    t.textBaseline = "alphabetic";
    state.teksten.forEach(function (tekst) {
      var inhoud = (tekst.inhoud || "").trim();
      if (!inhoud) { return; }
      var px = zetFont(t, tekst);
      t.fillStyle = tekst.kleur;
      var b = t.measureText(inhoud).width;
      t.fillText(inhoud, tekst.x * d - b / 2, tekst.y * d + px * 0.35);
    });
  }

  /** Alles binnen de cirkel, met (0,0) op de linkerbovenhoek van de sticker. */
  function tekenOp(t, metGrepen) {
    t.save();
    clipCirkel(t);
    tekenOndergrond(t);
    if (state.logo && state.logo.beeld) {
      var r = logoRechthoek();
      t.drawImage(state.logo.beeld, r.x, r.y, r.b, r.h);
    }
    tekenTeksten(t);
    t.restore();

    // De snijlijn, zodat de klant ziet waar de sticker ophoudt.
    t.save();
    t.beginPath();
    t.arc(mmx(MAAT_MM / 2), mmx(MAAT_MM / 2), mmx(MAAT_MM / 2), 0, Math.PI * 2);
    t.strokeStyle = "rgba(0,0,0,0.22)";
    t.lineWidth = 1;
    t.stroke();
    t.restore();

    if (!metGrepen) { return; }
    var greep = logoGreep();
    if (!greep) { return; }
    t.save();
    t.fillStyle = "#ffffff";
    t.strokeStyle = "#de0c14";
    t.lineWidth = 2;
    t.fillRect(greep.x, greep.y, greep.b, greep.h);
    t.strokeRect(greep.x, greep.y, greep.b, greep.h);
    t.restore();
  }

  /** zonderGrepen = true tekent hetzelfde beeld zonder het sleepblokje, dat is
      wat taak 5 in de snapshot wil hebben. */
  function teken(zonderGrepen) {
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    ctx.fillStyle = "#f6f6f6";
    ctx.fillRect(0, 0, LOGISCH, LOGISCH);

    ctx.save();
    ctx.translate(mmx(margeMm()), mmx(margeMm()));
    tekenOp(ctx, !zonderGrepen);
    ctx.restore();

    controleerRanden();
    meldKleineTekst();
  }

  /* ---------- loopt er iets over de rand? ---------- */

  /** Een rechthoek zit binnen de cirkel als al zijn VIER hoekpunten binnen de
      straal vallen. Op het middelpunt kijken is niet genoeg: een brede regel
      staat dan keurig in het midden en steekt er toch aan twee kanten uit. */
  function binnenCirkel(r) {
    if (!r) { return true; }
    var m = mmx(MAAT_MM / 2);
    var straal = mmx(MAAT_MM / 2);
    var hoeken = [
      [r.x, r.y], [r.x + r.b, r.y],
      [r.x, r.y + r.h], [r.x + r.b, r.y + r.h]
    ];
    for (var i = 0; i < hoeken.length; i++) {
      var dx = hoeken[i][0] - m;
      var dy = hoeken[i][1] - m;
      if (Math.sqrt(dx * dx + dy * dy) > straal) { return false; }
    }
    return true;
  }

  function controleerRanden() {
    var buiten = [];
    if (state.logo && !binnenCirkel(logoRechthoek())) { buiten.push("je logo"); }
    state.teksten.forEach(function (t, i) {
      if (t.inhoud && !binnenCirkel(tekstRechthoek(t))) {
        buiten.push("tekstregel " + (i + 1));
      }
    });
    var vak = document.getElementById("rs-waarschuwing");
    if (!vak) { return; }
    if (!buiten.length) { vak.hidden = true; vak.textContent = ""; return; }
    vak.hidden = false;
    vak.textContent = buiten.join(" en ") + " loopt over de rand. Je kunt gewoon "
      + "bestellen, we kijken er voor het drukken naar.";
  }

  /* ---------- slepen en schalen ---------- */

  function punt(evt) {
    var vak = canvas.getBoundingClientRect();
    // van schermpixels naar de logische tekenruimte. Niet canvas.width
    // gebruiken: die telt de ECHTE pixels, en op een retinascherm zijn dat er
    // meer. Dan wijst elke muisklik naar de verkeerde plek en pakt het slepen
    // niets (gevonden in de PV-studio op 2026-08-26).
    var schaal = LOGISCH / vak.width;
    return {
      x: (evt.clientX - vak.left) * schaal - mmx(margeMm()),
      y: (evt.clientY - vak.top) * schaal - mmx(margeMm())
    };
  }

  function inRechthoek(p, r, speling) {
    if (!r) { return false; }
    speling = speling === undefined ? 4 : speling;
    return p.x >= r.x - speling && p.x <= r.x + r.b + speling &&
           p.y >= r.y - speling && p.y <= r.y + r.h + speling;
  }

  function pakOp(p) {
    // van boven naar beneden in tekenvolgorde: eerst het sleepblokje, dan de
    // teksten, dan het logo.
    if (inRechthoek(p, logoGreep(), 2)) { return { soort: "logoschaal" }; }
    for (var i = state.teksten.length - 1; i >= 0; i--) {
      if (inRechthoek(p, tekstRechthoek(state.teksten[i]))) {
        return { soort: "tekst", index: i };
      }
    }
    if (inRechthoek(p, logoRechthoek())) { return { soort: "logo" }; }
    return null;
  }

  function verplaats(greep, p) {
    var d = doorsnedePx();
    if (greep.soort === "logoschaal") {
      // de afstand tot het midden van het logo bepaalt de nieuwe breedte
      var afstand = Math.abs(p.x - state.logo.x * d) * 2;
      state.logo.breedte = klem(afstand / d, 0.05, 2.5);
      return;
    }
    var doel = greep.soort === "logo" ? state.logo : state.teksten[greep.index];
    // Vrij plaatsen, ook over de rand van de sticker heen. De enige klem is de
    // rand van het tekenvlak zelf, anders raakt de klant zijn logo kwijt buiten
    // beeld en kan hij het niet meer terugslepen.
    doel.x = klem((p.x - greep.grijpX) / d, -MARGE_DEEL, 1 + MARGE_DEEL);
    doel.y = klem((p.y - greep.grijpY) / d, -MARGE_DEEL, 1 + MARGE_DEEL);
  }

  canvas.addEventListener("pointerdown", function (evt) {
    var p = punt(evt);
    var greep = pakOp(p);
    if (!greep) { return; }
    var d = doorsnedePx();
    if (greep.soort !== "logoschaal") {
      var doel = greep.soort === "logo" ? state.logo : state.teksten[greep.index];
      greep.grijpX = p.x - doel.x * d;
      greep.grijpY = p.y - doel.y * d;
    }
    sleep = greep;
    if (canvas.setPointerCapture) { canvas.setPointerCapture(evt.pointerId); }
    canvas.classList.add("is-slepend");
    evt.preventDefault();
  });

  canvas.addEventListener("pointermove", function (evt) {
    if (!sleep) {
      var onder = pakOp(punt(evt));
      canvas.style.cursor = !onder ? "default"
        : (onder.soort === "logoschaal" ? "nwse-resize" : "grab");
      return;
    }
    verplaats(sleep, punt(evt));
    teken();
  });

  function laatLos(evt) {
    if (!sleep) { return; }
    sleep = null;
    canvas.classList.remove("is-slepend");
    if (evt && evt.pointerId !== undefined && canvas.hasPointerCapture &&
        canvas.hasPointerCapture(evt.pointerId)) {
      canvas.releasePointerCapture(evt.pointerId);
    }
  }
  canvas.addEventListener("pointerup", laatLos);
  canvas.addEventListener("pointercancel", laatLos);

  /* ---------- de galerij ---------- */

  function tegelGegevens(knop) {
    var naamEl = knop.querySelector(".rs-tegel-naam");
    return {
      naam: (naamEl ? naamEl.textContent : knop.getAttribute("title") || "").trim(),
      bestand: knop.getAttribute("data-bestand") || "",
      laag: knop.getAttribute("data-laag") || "",
      ring: knop.getAttribute("data-ring") || "",
      cijfer: knop.getAttribute("data-cijfer") || "",
      url: knop.getAttribute("data-groot") || ""
    };
  }

  function kiesBord(knop, tegels) {
    var gegevens = tegelGegevens(knop);
    tegels.forEach(function (t) {
      var actief = t === knop;
      t.classList.toggle("is-actief", actief);
      t.setAttribute("aria-pressed", actief ? "true" : "false");
    });
    state.bord = gegevens;
    if (!gegevens.url) {
      state.bordBeeld = null;
      toonFout("Dit bord heeft geen afbeelding, kies er een andere of laat het "
        + "ons even weten.");
      teken();
      return;
    }
    laadBeeld(gegevens.url, function (img) {
      if (!img) {
        state.bordBeeld = null;
        toonFout("Het bord \"" + gegevens.naam + "\" kon niet geladen worden. "
          + "Ververs de pagina eens, dan proberen we het opnieuw.");
      } else {
        state.bordBeeld = img;
        toonFout("");
      }
      teken();
    });
  }

  function startGalerij() {
    var galerij = document.getElementById("rs-galerij");
    if (!galerij) { return; }          // het product "eigen logo" heeft geen borden
    var tegels = [];
    var knoppen = galerij.querySelectorAll(".rs-tegel");
    for (var i = 0; i < knoppen.length; i++) { tegels.push(knoppen[i]); }
    if (!tegels.length) { return; }
    tegels.forEach(function (knop) {
      knop.addEventListener("click", function () { kiesBord(knop, tegels); });
    });
    var start = galerij.querySelector(".rs-tegel.is-actief") || tegels[0];
    kiesBord(start, tegels);
  }

  /* ---------- maat, aantal en prijs ---------- */

  var VARIANTEN = [];
  (function leesVarianten() {
    var blok = document.getElementById("rs-varianten");
    if (!blok) { return; }
    try {
      var rijen = JSON.parse(blok.textContent) || [];
      VARIANTEN = rijen.map(function (v) {
        var delen = String(v.titel || "").split("/");
        return {
          id: v.id,
          prijs: v.prijs,
          titel: v.titel,
          maat: (delen[0] || "").trim(),
          aantal: (delen[1] || "").trim()
        };
      });
    } catch (fout) {
      VARIANTEN = [];
      toonFout("De maten en aantallen zijn niet goed geladen. Ververs de pagina "
        + "eens, dan staan ze er meestal weer.");
    }
  })();

  function euro(centen) {
    return "€ " + (centen / 100).toFixed(2).replace(".", ",");
  }

  /** "7,5 cm" wordt 75 mm, "35 cm" wordt 350 mm. */
  function maatNaarMm(label) {
    var getal = parseFloat(String(label).replace(",", ".").replace(/[^0-9.]/g, ""));
    if (!getal || isNaN(getal)) { return MAAT_MM; }
    return /mm/i.test(label) ? getal : getal * 10;
  }

  function uniek(lijst) {
    var uit = [];
    lijst.forEach(function (w) { if (uit.indexOf(w) < 0) { uit.push(w); } });
    return uit;
  }

  function vulKeuze(el, waarden, gekozen) {
    if (!el) { return; }
    el.innerHTML = "";
    waarden.forEach(function (w) {
      var optie = document.createElement("option");
      optie.value = w;
      optie.textContent = w;
      el.appendChild(optie);
    });
    el.value = waarden.indexOf(gekozen) >= 0 ? gekozen : waarden[0];
  }

  function huidigeVariant() {
    for (var i = 0; i < VARIANTEN.length; i++) {
      if (VARIANTEN[i].maat === state.maat && VARIANTEN[i].aantal === state.aantal) {
        return VARIANTEN[i];
      }
    }
    return null;
  }

  function toonPrijs() {
    var el = document.getElementById("rs-prijs");
    var variant = huidigeVariant();
    state.variantId = variant ? variant.id : null;
    if (!el) { return; }
    el.textContent = variant ? euro(variant.prijs) : "";
  }

  /** Niet elke combinatie bestaat: bij 35 cm gaat het om 1 tot 25 stuks, bij
      3 cm om 25 tot 500. Daarom loopt de aantallenlijst mee met de maat. */
  function verversAantallen() {
    var keuze = document.getElementById("rs-aantal");
    var passend = VARIANTEN.filter(function (v) { return v.maat === state.maat; });
    var aantallen = uniek(passend.map(function (v) { return v.aantal; }));
    vulKeuze(keuze, aantallen, state.aantal);
    state.aantal = keuze ? keuze.value : aantallen[0];
    toonPrijs();
  }

  function startMaatEnAantal() {
    var maatKeuze = document.getElementById("rs-maat");
    var aantalKeuze = document.getElementById("rs-aantal");
    if (!VARIANTEN.length) { return; }
    var maten = uniek(VARIANTEN.map(function (v) { return v.maat; }));
    state.maat = maten[0];
    vulKeuze(maatKeuze, maten, state.maat);
    verversAantallen();
    zetMaat(maatNaarMm(state.maat));

    if (maatKeuze) {
      maatKeuze.addEventListener("change", function () {
        state.maat = maatKeuze.value;
        zetMaat(maatNaarMm(state.maat));
        verversAantallen();
        gelijkTrekkenSchuiven();
        teken();
      });
    }
    if (aantalKeuze) {
      aantalKeuze.addEventListener("change", function () {
        state.aantal = aantalKeuze.value;
        toonPrijs();
      });
    }
  }

  /* ---------- de tekstvelden ---------- */

  /** Na een maatwissel kan de ondergrens van 7 pt hoger liggen dan waar de
      schuif staat. Dan trekt de tekst mee omhoog, zodat het beeld klopt met
      wat er gedrukt wordt. */
  function gelijkTrekkenSchuiven() {
    state.teksten.forEach(function (tekst) {
      tekst.schaal = Math.max(minimaleSchaal(), tekst.ruw);
    });
  }

  function startTeksten() {
    state.teksten.forEach(function (tekst, i) {
      var nr = i + 1;
      var veld = document.getElementById("rs-tekst" + nr);
      var fontKeuze = document.getElementById("rs-font" + nr);
      var schuif = document.getElementById("rs-grootte" + nr);
      var kleur = document.getElementById("rs-kleur" + nr);

      if (veld) {
        veld.addEventListener("input", function () {
          tekst.inhoud = veld.value;
          teken();
        });
      }
      if (fontKeuze) {
        // de liquid laat de lijst leeg, hier komen de vijf lettertypes erin
        if (!fontKeuze.options.length) {
          FONTS.forEach(function (f) {
            var optie = document.createElement("option");
            optie.value = f.sleutel;
            optie.textContent = f.naam;
            optie.style.fontFamily = f.css;
            fontKeuze.appendChild(optie);
          });
        }
        fontKeuze.value = tekst.font;
        fontKeuze.addEventListener("change", function () {
          tekst.font = fontKeuze.value;
          teken();
        });
      }
      if (schuif) {
        zetSchaalUitSchuif(tekst, schuif.value);
        schuif.addEventListener("input", function () {
          zetSchaalUitSchuif(tekst, schuif.value);
          teken();
        });
      }
      if (kleur) {
        tekst.kleur = kleur.value || STANDAARD_KLEUR;
        kleur.addEventListener("input", function () {
          tekst.kleur = kleur.value;
          teken();
        });
      }
    });
  }

  /* ---------- het logo uploaden ---------- */

  function zetLogoBeeld(beeld) {
    if (!state.logo) {
      state.logo = { beeld: null, url: "", x: 0.5, y: 0.3, breedte: 0.3 };
    }
    state.logo.beeld = beeld;
    teken();
  }

  function kiesLogo(bestand) {
    if (!bestand) { return; }
    if (bestand.size > MAX_UPLOAD_MB * 1024 * 1024) {
      toonLogoStatus("Dit bestand is groter dan " + MAX_UPLOAD_MB + " MB.", true);
      return;
    }
    toonLogoStatus("Bezig met uploaden...");
    state.bezig = true;
    bijwerkenKnop();

    // eerst lokaal laten zien, dan hoeft de klant niet op de upload te wachten
    var lezer = new FileReader();
    lezer.onload = function () {
      laadBeeld(lezer.result, function (img) {
        if (img) {
          zetLogoBeeld(img);
        } else {
          toonLogoStatus("Dit bestand kunnen we niet als beeld lezen. Probeer "
            + "een PNG, JPG of SVG.", true);
        }
      });
    };
    lezer.onerror = function () {
      toonLogoStatus("Dit bestand kunnen we niet lezen. Probeer een ander.", true);
    };
    lezer.readAsDataURL(bestand);

    var fd = new FormData();
    fd.append("bestand", bestand);
    fetch(UPLOAD_URL, { method: "POST", body: fd })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, j: j || {} }; });
      })
      .then(function (res) {
        state.bezig = false;
        if (!res.ok || !res.j.url) {
          toonLogoStatus(res.j.fout || "Uploaden is niet gelukt.", true);
          if (state.logo) { state.logo.url = ""; }
        } else {
          if (!state.logo) { zetLogoBeeld(null); }
          state.logo.url = res.j.url;
          toonLogoStatus("Logo geplaatst. Sleep het in het voorbeeld op zijn plek "
            + "en trek het blokje rechtsonder om het groter te maken.");
        }
        bijwerkenKnop();
      })
      .catch(function () {
        state.bezig = false;
        if (state.logo) { state.logo.url = ""; }
        toonLogoStatus("Uploaden is niet gelukt. Probeer het nog eens.", true);
        bijwerkenKnop();
      });
  }

  function startLogo() {
    var invoer = document.getElementById("rs-logo");
    if (invoer) {
      invoer.addEventListener("change", function () {
        kiesLogo(invoer.files && invoer.files[0]);
      });
    }
    var dropzone = document.getElementById("rs-dropzone");
    if (!dropzone) { return; }
    ["dragenter", "dragover"].forEach(function (naam) {
      dropzone.addEventListener(naam, function (e) {
        e.preventDefault();
        dropzone.classList.add("is-actief");
      });
    });
    ["dragleave", "drop"].forEach(function (naam) {
      dropzone.addEventListener(naam, function (e) {
        e.preventDefault();
        dropzone.classList.remove("is-actief");
      });
    });
    dropzone.addEventListener("drop", function (e) {
      if (e.dataTransfer && e.dataTransfer.files.length) {
        kiesLogo(e.dataTransfer.files[0]);
      }
    });
  }

  /* ---------- naar de winkelwagen ---------- */

  function rond(v) { return Number(Number(v).toFixed(4)); }

  function laagVeld() {
    if (!state.bord) { return ""; }
    if (state.bord.ring && state.bord.cijfer) {
      return state.bord.ring + " + " + state.bord.cijfer;
    }
    return state.bord.laag || "";
  }

  /** De eigenschappen die op de orderregel komen. De velden met een streepje
      ervoor toont Shopify niet aan de klant, maar ze staan wel op de order;
      maak_drukvel leest ze straks terug. */
  function regeleigenschappen() {
    return {
      "Bord": state.bord ? state.bord.naam : "Geen pictogram",
      "Maat": state.maat || "",
      "Tekst 1": (state.teksten[0].inhoud || "").trim(),
      "Tekst 2": (state.teksten[1].inhoud || "").trim(),
      "Tekst 3": (state.teksten[2].inhoud || "").trim(),
      "_Laag": laagVeld(),
      "_LogoURL": state.logo ? (state.logo.url || "") : "",
      "_LogoPositie": state.logo ? JSON.stringify({
        x: rond(state.logo.x), y: rond(state.logo.y), schaal: rond(state.logo.breedte)
      }) : "",
      "_TekstOpmaak": JSON.stringify(state.teksten.map(function (t) {
        return {
          x: rond(t.x), y: rond(t.y), schaal: rond(t.schaal),
          kleur: t.kleur, font: t.font
        };
      })),
      "_SnapshotURL": state.snapshotUrl || ""
    };
  }

  function bijwerkenKnop() {
    var knop = document.getElementById("rs-bestel");
    if (!knop) { return; }
    knop.disabled = state.bezig;
    knop.textContent = state.bezig ? "Even geduld..." : "In winkelwagen";
  }

  var FORMULIERVELDEN = {
    "Bord": "rs-form-bord",
    "Maat": "rs-form-maat",
    "Tekst 1": "rs-form-tekst1",
    "Tekst 2": "rs-form-tekst2",
    "Tekst 3": "rs-form-tekst3",
    "_Laag": "rs-form-laag",
    "_LogoURL": "rs-form-logourl",
    "_LogoPositie": "rs-form-logopositie",
    "_TekstOpmaak": "rs-form-tekstopmaak",
    "_SnapshotURL": "rs-form-snapshoturl"
  };

  function vulFormulier() {
    var eigenschappen = regeleigenschappen();
    Object.keys(FORMULIERVELDEN).forEach(function (sleutel) {
      var el = document.getElementById(FORMULIERVELDEN[sleutel]);
      if (el) { el.value = eigenschappen[sleutel]; }
    });
    var idVeld = document.getElementById("rs-form-id");
    if (idVeld) { idVeld.value = state.variantId ? String(state.variantId) : ""; }
  }

  /** Legt vast wat de klant zag, zonder het sleepblokje van het logo: dat
      hoort niet op de foto die naar de order gaat. Lukt de upload niet, dan
      geeft deze functie een lege string door. De bestelling gaat dan gewoon
      door met een lege _SnapshotURL; een klant mag niet stranden omdat een
      plaatje niet geupload kon worden, en Richard heeft de laag en de
      posities om het vel alsnog te bouwen. */
  function maakSnapshot(klaar) {
    if (!canvas.toBlob) { klaar(""); return; }
    teken(true);
    canvas.toBlob(function (blob) {
      teken();
      if (!blob) { klaar(""); return; }
      var fd = new FormData();
      fd.append("bestand", blob, "snapshot.png");
      fetch(UPLOAD_URL, { method: "POST", body: fd })
        .then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, j: j || {} }; });
        })
        .then(function (res) { klaar(res.ok && res.j.url ? res.j.url : ""); })
        .catch(function () { klaar(""); });
    }, "image/png");
  }

  /** De echte winkelwagen-post, via /cart/add.js zoals de PV- en de
      keuringsstickers-studio dat ook doen (in plaats van een gewone
      formulierpost: die mist een return_to en laat de klant dan de kale
      JSON-respons zien in plaats van zijn winkelwagen). De hidden inputs in
      #rs-form blijven de ene bron van de waarheid: vulFormulier() zet ze en
      hier gaat de FormData er zo uit mee. */
  function voegToeAanWinkelwagen(formulier) {
    fetch("/cart/add.js", { method: "POST", body: new FormData(formulier) })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) {
          state.bezig = false;
          bijwerkenKnop();
          toonFout((res.data && res.data.description)
            || "Toevoegen aan de winkelwagen is niet gelukt. Probeer het nog eens.");
          return;
        }
        window.location.href = "/cart";
      })
      .catch(function () {
        state.bezig = false;
        bijwerkenKnop();
        toonFout("Toevoegen aan de winkelwagen is niet gelukt. Probeer het nog eens.");
      });
  }

  function bestel() {
    if (state.bezig) { return; }
    toonFout("");
    if (!state.variantId) {
      toonFout("Kies eerst een maat en een aantal.");
      return;
    }
    var formulier = document.getElementById("rs-form");
    if (!formulier) { return; }
    state.bezig = true;
    bijwerkenKnop();

    maakSnapshot(function (url) {
      state.snapshotUrl = url || "";
      vulFormulier();
      if (!url) {
        toonFout("De foto van je ontwerp uploaden lukte niet, maar je bestelling "
          + "gaat gewoon door. We bouwen je sticker met de gegevens die we al "
          + "hebben.");
        // Even laten staan zodat de klant dit ook echt kan lezen voor de
        // pagina naar de winkelwagen navigeert.
        window.setTimeout(function () { voegToeAanWinkelwagen(formulier); },
          MELDING_PAUZE_MS);
        return;
      }
      voegToeAanWinkelwagen(formulier);
    });
  }

  /* ---------- opstarten ---------- */

  function hiDPI() {
    // Alleen de scherpte: meer echte pixels, dezelfde logische tekenruimte. De
    // CSS bepaalt hoe groot het canvas op het scherm staat, dus hier geen
    // inline breedte zetten.
    DPR = window.devicePixelRatio || 1;
    canvas.width = LOGISCH * DPR;
    canvas.height = LOGISCH * DPR;
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
  }

  window.RondeStudio = {
    state: state,
    teken: teken,
    regeleigenschappen: regeleigenschappen,
    vulFormulier: vulFormulier,
    binnenCirkel: binnenCirkel,
    logoRechthoek: logoRechthoek,
    tekstRechthoek: tekstRechthoek,
    minimaleSchaal: minimaleSchaal,
    fonts: FONTS
  };

  zetMaat(MAAT_MM);
  hiDPI();
  startMaatEnAantal();
  startTeksten();
  startLogo();
  startGalerij();
  bijwerkenKnop();

  var bestelknop = document.getElementById("rs-bestel");
  if (bestelknop) { bestelknop.addEventListener("click", bestel); }

  window.addEventListener("resize", function () {
    if ((window.devicePixelRatio || 1) === DPR) { return; }
    hiDPI();
    teken();
  });

  teken();
})();
